import { useRef } from 'react';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import SecondaryButton from 'components/buttons/SecondaryButton';

import {
    ACCEPT_FILE_TYPES,
    FILE_INPUT_TEST_ID,
    TEST_ID,
    TRIGGER_BUTTON_TEST_ID
} from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ShapefileDropZone: FunctionComponent<Props> = ({
    className = '',
    hint,
    isProcessing,
    onFilesSelected,
    processingText,
    testId = TEST_ID,
    triggerText
}) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleTriggerClick = () => {
        if (isProcessing) {
            return;
        }

        inputRef.current?.click();
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files ? Array.from(event.target.files) : [];

        // Reset the input so re-uploading the same files re-fires onChange.
        event.target.value = '';

        onFilesSelected({ files });
    };

    const hintText = isProcessing ? processingText : hint;

    return (
        <VerticalContainer className={`${className} ${styles.shapefileDropZone}`} testId={testId}>
            <input
                accept={ACCEPT_FILE_TYPES}
                className={styles.hiddenInput}
                data-testid={FILE_INPUT_TEST_ID}
                multiple
                onChange={handleInputChange}
                ref={inputRef}
                type='file'
            />

            <Wrapper className={styles.hint}>{hintText}</Wrapper>

            <SecondaryButton
                isDisabled={isProcessing}
                onClick={handleTriggerClick}
                testId={TRIGGER_BUTTON_TEST_ID}
                text={triggerText}
            />
        </VerticalContainer>
    );
};

export default ShapefileDropZone;
